/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Dropdown, Button, Icon, Menu } from "antd";

export const DropDown = (props) => {
  const selectItem = (e) => {
    props.onChange && props.onChange(e);
  }

  const options = props.options;

  const menu = (
    <Menu onClick={selectItem}>
      {options.map(a => {
        return <Menu.Item {...a} key={a.value}>{a.title}</Menu.Item>
      })}

    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
        <Button>
        {`${props.text}`} <Icon type="down" />
        </Button>
    </Dropdown>
  );
};